import React, { useState, useRef, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StoryCard from "./StoryCard";
import { t } from "@lingui/macro";

const StoryRow = ({ story }) => {
  const theme = useTheme();
  const titleRef = useRef(null);
  const timerRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = () => {
    timerRef.current = setTimeout(() => {
      if (titleRef.current) {
        const rect = titleRef.current.getBoundingClientRect();
        const cardWidth = 140;
        const cardHeight = 238;
        const spacing = 8;

        let left = rect.left;
        let top = rect.bottom + spacing;

        // Adjust horizontally if the card would overflow right edge
        if (left + cardWidth > window.innerWidth - spacing) {
          left = window.innerWidth - cardWidth - spacing;
        }
        if (left < spacing) left = spacing;

        // Adjust vertically if the card would overflow bottom edge
        if (top + cardHeight > window.innerHeight - spacing) {
          top = rect.top - cardHeight - spacing;
          if (top < spacing) top = spacing;
        }

        setPosition({ top, left });
        setHovered(true);
      }
    }, 200); // 0.2 second delay as requested
  };

  const handleMouseLeave = () => {
    clearTimeout(timerRef.current);
    setHovered(false);
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: "relative",
      }}
    >
      <Typography
        ref={titleRef}
        variant="body2"
        sx={{ width: "20%", fontWeight: 500, cursor: "pointer" }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {story.title}
      </Typography>
      <Typography variant="body2" sx={{ width: "15%" }}>
        {story.writerName || t`Unknown Author`}
      </Typography>
      <Typography variant="body2" sx={{ width: "10%" }}>
        {story.isPublished ? t`Published` : t`Saved`}
      </Typography>
      <Typography variant="body2" sx={{ width: "10%" }}>
        {story.isActive ? t`Active` : t`Inactive`}
      </Typography>
      <Typography variant="body2" sx={{ width: "10%" }}>
        {story.isFlagged ? t`Flagged` : "-"}
      </Typography>
      <Typography variant="body2" sx={{ width: "15%" }}>
        {story.publishedAt
          ? new Date(story.publishedAt._seconds * 1000).toLocaleDateString()
          : "-"}
      </Typography>
      <Typography variant="body2" sx={{ width: "15%" }}>
        {story.updatedAt
          ? new Date(story.updatedAt._seconds * 1000).toLocaleDateString()
          : "-"}
      </Typography>
      <Typography variant="body2" sx={{ width: "5%" }}>
        {story.priority ?? "-"}
      </Typography>

      {hovered && (
        <Box
          sx={{
            position: "fixed", // <- crucial change here
            zIndex: 1000,
            top: position.top,
            left: position.left,
            boxShadow: theme.shadows[10],
            borderRadius: 1,
            pointerEvents: "none",
          }}
        >
          <StoryCard story={story} />
        </Box>
      )}
    </Box>
  );
};

export default StoryRow;
